interface V3IconVideoProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconVideo = ({ stroke = "#ABB0BA" }: V3IconVideoProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.667 3.333v9.334l8-4.667-8-4.667ZM13.334 3.333v9.334" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>